import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from 'app/shared/shared.module';
import { InscricaoModule } from './inscricao/inscricao.module';
import { VestibularRouter } from './vestibular.router';
import { AcompanhamentoModule } from './acompanhamento/acompanhamento.module';

import { VestibularService } from './shared/vestibular.service';
import { PessoaService } from 'app/shared/pessoa/pessoa.service';
import { PdfResuldadosService } from './resultados/shared/pdf-resuldados.service';

import { VestibularComponent } from './vestibular.component';
import { VestibularCeumaComponent } from './ceuma/ceuma.component';
import { EditaisManuaisComponent } from './editais-manuais/editais-manuais.component';
import { ProvasAplicadasComponent } from './provas-aplicadas/provas-aplicadas.component';
import { ResultadosComponent } from './resultados/resultados.component';
import { CalendarioComponent } from './calendario/calendario.component';
import { InscricaoVestibularComponent } from './inscricao-vestibular-novo/inscricao-vestibular.component';
import { FormsModule } from '@angular/forms';
import { PdfDocInformacoesFinanceirasService } from '../restrito/contratante/matricular/shared/pdf/doc-informacoes-financeiras/pdf-doc-informacoes-financeiras.service';
import { RedirecionamentoComponent } from './redirecionamento/redirecionamento.component';


@NgModule({
  imports: [
    CommonModule,
    SharedModule,
    InscricaoModule,
    VestibularRouter,
    AcompanhamentoModule,
    FormsModule
  ],
  providers: [
    VestibularService,
    PessoaService,
    PdfResuldadosService,
    PdfDocInformacoesFinanceirasService
  ],
  declarations: [
    VestibularComponent,
    VestibularCeumaComponent,
    EditaisManuaisComponent,
    ProvasAplicadasComponent,
    ResultadosComponent,
    CalendarioComponent,
    InscricaoVestibularComponent,
    RedirecionamentoComponent
  ],
})
export class VestibularModule { }
